/**
 * @enum {string}
 * @memberof customer-metadata
 * @property {string} STRING
 * @property {string} DATE
 * @property {string} BOOLEAN
 * @property {string} INTEGER
 * @property {string} FLOAT
 */
var ColumnDataType;
(function (ColumnDataType) {
    ColumnDataType["STRING"] = "str";
    ColumnDataType["DATE"] = "date";
    ColumnDataType["BOOLEAN"] = "bool";
    ColumnDataType["INTEGER"] = "int";
    ColumnDataType["FLOAT"] = "float";
})(ColumnDataType || (ColumnDataType = {}));
ColumnDataType[ColumnDataType.STRING] = ColumnDataType.STRING;
ColumnDataType[ColumnDataType.DATE] = ColumnDataType.DATE;
ColumnDataType[ColumnDataType.BOOLEAN] = ColumnDataType.BOOLEAN;
ColumnDataType[ColumnDataType.INTEGER] = ColumnDataType.INTEGER;
ColumnDataType[ColumnDataType.FLOAT] = ColumnDataType.FLOAT;
export default ColumnDataType;
